/*******************************************************
* MicrosoftLoginButton Component
*
* Button component that handles Microsoft OAuth login integration
*
* Key Features:
* - Provides Microsoft Oauth login functionality
* - Custom Microsoft logo icon
* - Consistent styling with app theme
* - Secure OAuth flow with state parameter for CSRF protection
********************************************************/
'use client';
//########## IMPORTS ##########
// #region IMPORTS
import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { Microsoft } from '@mui/icons-material';
// #endregion

//########## TYPE DEFINITIONS ##########
//#region TYPE DEFINITIONS

//#endregion

//########## CONSTANTS & Global Variables ##########
//#region CONSTANTS

//#endregion

//########## FUNCTIONS ##########
// #region FUNCTIONS

//#endregion

export default function MicrosoftLoginButton() {
  //########## MAIN LOGIC ##########
  // #region MAIN LOGIC
  const [loading, setLoading] = useState(false);

  const handleMicrosoftLogin = async () => {
    setLoading(true);
    try {
      // Fetch login URL from server (sets OAuth state cookie)
      const response = await fetch('/api/v1/Auth/Entra');
      if (!response.ok) {
        throw new Error('Failed to get login URL');
      }
      const { url } = await response.json() as { url: string };
      window.location.href = url;
    } catch (error) {
      console.error('Failed to initiate Microsoft login:', error);
      setLoading(false);
    }
  };
  //#endregion

  //########## MARKDOWN ##########
  // #region MARKDOWN
  return (
    <Button
      onClick={handleMicrosoftLogin}
      variant="contained"
      fullWidth
      size="large"
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Microsoft />}
      color="primary"
      disabled={loading}
      sx={{
        textTransform: 'none',
        fontWeight: 600,
      }}
    >
      {loading ? 'Connecting...' : 'Sign in with Microsoft'}
    </Button>
  );
  //#endregion
}
